const FPS = 30;
const TOTAL_FRAMES = 20 * FPS; // 20 s, mirrors v1 default for offer-square-1.
export const offerSquare1 = {
    id: 'offer-square-1',
    schemaVersion: 2,
    aspectRatios: ['square'],
    duration: { kind: 'fixed', frames: TOTAL_FRAMES },
    root: {
        kind: 'split',
        axis: 'h',
        // v1 used 3/5 + 2/5 (648px + 432px on a 1080 canvas). Preserve that
        // ratio so the converter's compile pass produces the same proportions.
        children: [
            // Left pane — procedure b-roll, fast cuts driven by music beat.
            {
                ratio: 3,
                region: {
                    kind: 'leaf',
                    id: 'media-pane',
                    spine: [
                        {
                            kind: 'media-track',
                            id: 'broll',
                            duration: { kind: 'fill' },
                            clips: {
                                source: 'query',
                                query: {
                                    kind: 'asset-clips',
                                    // v1 used `procedure` for offer footage (see template-
                                    // definitions.ts variation clipGuidance). The v1 hint
                                    // says "AI will cut clips to the beat".
                                    tag: 'procedure',
                                    // v1 recommendedClipCount: 3, maxBRollClips: 4.
                                    count: [1, 4],
                                },
                                required: true,
                            },
                            fit: 'contain-blur',
                            cuts: { mode: 'beat-synced', beatsPerEdit: 2 },
                            transition: 'cut',
                            kenBurnsOnImages: true,
                            fillMode: 'loop',
                        },
                    ],
                    overlays: [],
                },
            },
            // Right pane — solid background + info-card overlay.
            {
                ratio: 2,
                region: {
                    kind: 'leaf',
                    id: 'card-pane',
                    spine: [
                        {
                            kind: 'solid',
                            id: 'card-bg',
                            duration: { kind: 'fill' },
                            // White-pane background matches v1 `SquareOfferPane`
                            // (#FFFFFF). The converter swaps this for brand surface
                            // colour when a brand-kit theme is present.
                            color: { source: 'fixed', value: '#FFFFFF' },
                        },
                    ],
                    overlays: [
                        {
                            kind: 'info-card',
                            id: 'offer-card',
                            // Left-aligned benefit list (v1 SquareOfferPane), not a centred
                            // block — headline + checkmark bullets read top-down, CTA pinned
                            // to the bottom of the pane by the renderer.
                            layout: 'left-aligned',
                            presentation: 'offer',
                            background: { kind: 'solid', color: '#FFFFFF' },
                            entrance: { animation: 'spring-in' },
                            duration: { kind: 'fill' },
                        },
                    ],
                },
            },
        ],
    },
    globals: {
        audio: {
            // No narration on offer-square-1 (v1 narrationMode: 'text_only').
            // Background music drives the cut cadence on the media pane.
            music: {
                source: 'query',
                query: { kind: 'music', mood: 'energetic', bpm: [100, 130] },
                required: false,
            },
        },
        // No captions — offer videos are music-only, no narration to transcribe.
    },
};
//# sourceMappingURL=offer-square-1.js.map